import React, { useEffect, useRef } from 'react';
import $i18n from 'panda-i18n';
import { useSetState } from 'ahooks';
import { useHistory } from 'ice';
import { OUTBOUND_BOARD_DATA, RED_DATA, GREY_DATA } from '@/const';
import { getWarehouseCode, getLabelValue } from '@/utils';
import { outTipsOrder, outTipsPCS, outTipsPPO } from './index.services';
import { Box, Loading } from '@fpxfd/next';
import FpxBarChart from '@/components/FpxBarChart';
import { State, ListProps, Props } from './index.interface';
import { getAllOrderQty } from '@/pages/OutboundBillBoardHome/OrderBillBoard/index.service';

const OutboundBoard = ({ time, title, dark, reqDatas = undefined }: Props) => {
  const history = useHistory();

  const [state, setState] = useSetState<State>({
    outboundList: [],
    loading: false,
    totalOrder: 0,
  });

  const outboundRef: React.MutableRefObject<ListProps[]> = useRef([]);
  outboundRef.current = state.outboundList;
  const loadRef: React.MutableRefObject<boolean> = useRef(false);
  loadRef.current = state.loading;

  const initDatas = () => {
    let d2: ListProps[] = [];
    !outboundRef.current?.length && setState({ loading: true });
    const reqData = {
      customerCodes: reqDatas?.customerCode ? [reqDatas?.customerCode] : [],
      customerGroupSet: reqDatas?.customerGroup ? [reqDatas?.customerGroup] : [],
      warehouseCode: getWarehouseCode(),
    };

    // 获取当日总单量
    getAllOrderQty(reqData).then((res) => {
      if (res === state.totalOrder) return;
      setState({
        totalOrder: res,
      });
    });

    const stateParamValueFromReqData = { ...reqDatas };
    delete stateParamValueFromReqData.warehouseCode;

    // outTipsOrder、outTipsPCS、outTipsPPO三个接口都需要同时调用，确保数据完整后，再进行赋值。
    Promise.all([outTipsOrder(reqData), outTipsPCS(reqData), outTipsPPO(reqData)]).then(
      ([outRes = [], pcs = [], ppoRes = []]) => {
        const dimension = reqDatas?.dimension || 'OC';
        // 将返回的数据outRes、pcs、ppoRes进行处理，组装成d2。如果reqDatas?.dimension存在，则根据对应返回数据加上qty
        d2 = outRes?.map((e, i) => {
          const data =
            dimension === 'OC'
              ? { ...getLabelValue(OUTBOUND_BOARD_DATA, e?.link), qty: e?.num, OC: e?.num }
              : { ...getLabelValue(OUTBOUND_BOARD_DATA, e?.link), OC: e?.num };
          data.state = { ...data.state, time, ...stateParamValueFromReqData };
          return data;
        });
        d2 = pcs?.map((e) => {
          return dimension === 'PCS'
            ? { ...getLabelValue(d2, e?.link), qty: e?.num, PCS: e?.num }
            : { ...getLabelValue(d2, e?.link), PCS: e?.num };
        });
        d2 = ppoRes?.map((e) => {
          return dimension === 'PPO'
            ? { ...getLabelValue(d2, e?.link), qty: e?.num, PPO: e?.num }
            : { ...getLabelValue(d2, e?.link), PPO: e?.num };
        });
        if (JSON.stringify(d2) !== JSON.stringify(outboundRef.current)) {
          setState({
            outboundList: d2,
            loading: false,
          });
        }
      },
    );
  };

  useEffect(() => {
    console.log('reqDatas=============', reqDatas);
    initDatas();
    const timer = setInterval(() => {
      initDatas();
    }, 10000);
    return () => {
      clearInterval(timer);
    };
  }, [time, reqDatas]);

  return (
    <Loading visible={loadRef.current}>
      <FpxBarChart
        data={outboundRef.current}
        title={
          title || (
            <Box direction="row" justify="space-between">
              <span>{$i18n.get({ id: 'OutboundKanban.four_px', dm: '出库看板' })}</span>
              <span>{`${$i18n.get({ id: 'TotalQuantity.four_px', dm: '总单量' })}： ${state.totalOrder}`}</span>
            </Box>
          )
        }
        xField={'module'}
        yField={'qty'}
        xAxis={{
          label: {
            formatte: (e) => {
              if (e === $i18n.get({ id: 'PackagingIncludingUnsorted.four_px', dm: '打包（含未分拣）' })) {
                return $i18n.get({ id: 'DB.Packaging.four_px', dm: '打包' });
              }
              return e;
            },
          },
        }}
        color={(d) => {
          if (RED_DATA.includes(d.module)) return '#F98767';
          else if (GREY_DATA.includes(d.module)) return '#DEE1E4';
          return '#27D5B8';
        }}
        tooltip={{
          fields: ['OC', 'PCS', 'PPO'],
        }}
        events={{
          onBarClick: (event) => {
            event?.src && history.push({ pathname: event?.src, state: event?.state });
            // console.log('eventonBarClick=', event);
          },
          onPlotClick: (event) => {
            event?.src && history.push({ pathname: event?.src, state: event?.state });
            console.log('eventonPlotClick=', event);
          },
          onAxisXClick: (event) => {
            event?.src && history.push({ pathname: event?.src, state: event?.state });
            // console.log('eventonAxisXClick=', event);
          },
        }}
        dark={dark}
      />
    </Loading>
  );
};

export default OutboundBoard;
